module.exports = __webpack_public_path__ + "img/ofis-logo-black.19e3c2ba.svg";